'use strict';

var calendarModule = angular.module('t2g.calendar', [
  'gettext',
  'ui.router',
  'angularResizable',
  require('t2g.common.services.modalService').name,
  require('t2g.common.data-access.calendar').name,
  require('t2g.common.services.modelService').name,
]);

module.exports = calendarModule;

calendarModule.controller('AppointmentCtrl', require('./AppointmentCtrl'));
calendarModule.controller('AppointmentModalBaseCtrl', require('./AppointmentModalBaseCtrl'));
calendarModule.controller('AppointmentsCtrl', require('./AppointmentsCtrl'));
calendarModule.controller('CalendarContainerCtrl', require('./CalendarContainerCtrl'));
calendarModule.controller('CalendarCtrl', require('./CalendarCtrl'));
calendarModule.controller('CourseAppointmentModalCtrl', require('./CourseAppointmentModalCtrl'));
calendarModule.controller(
  'CustomerAppointmentModalCtrl',
  require('./CustomerAppointmentModalCtrl'),
);
calendarModule.controller('PrivateAppointmentModalCtrl', require('./PrivateAppointmentModalCtrl'));
calendarModule.directive('absentTimes', require('./absentTimesDirective'));
calendarModule.directive('appointment', require('./appointmentDirective'));
calendarModule.directive('appointments', require('./appointmentsDirective'));
calendarModule.directive('calendar', require('./calendarDirective'));
calendarModule.directive('calendarList', require('./calendarListDirective'));
calendarModule.directive('fixedTimeLine', require('./fixedTimeLineDirective'));
calendarModule.directive('timeline', require('./timelineDirective'));
calendarModule.factory('PixelTimeService', require('./PixelTimeCalcServce'));
calendarModule.factory('AppointmentDragAndResizeState', require('./AppointmentDragAndResizeState'));

calendarModule.constant('calendarSettings', {
  hourHeight: 72,
  offset: 5,
});

calendarModule.config(function($stateProvider) {
  $stateProvider.state('private.main.calendar', {
    url: '/calendar/:resource/:view/:date',
    templateUrl: '/app/modules/calendar/CalendarContainer.html?v=4.5.6',
    controller: 'CalendarContainerCtrl as CalendarContainerCtrl',
    title: 'Calendar',
    onExit: function($stateParams, LocalStorage) {
      LocalStorage.set('calendarView', {
        date: $stateParams.date,
        resource: $stateParams.resource,
        view: $stateParams.view,
      });
    },
    resolve: {
      calendar: function(CalendarDA, $stateParams) {
        var start;
        var view = $stateParams.view;
        var end;

        if (view === 'week' || view === 'list') {
          start = moment($stateParams.date)
            .startOf('week')
            .format('YYYY-MM-DD');
          end = moment(start)
            .add(6, 'days')
            .format('YYYY-MM-DD');
        } else if (view === '4days') {
          start = moment($stateParams.date).format('YYYY-MM-DD');
          end = moment(start)
            .add(3, 'days')
            .format('YYYY-MM-DD');
        } else {
          start = $stateParams.date;
          end = start;
        }

        return CalendarDA.get(start, end, $stateParams.resource);
      },
      resources: function(gettextCatalog, ResourceDA) {
        var resources = [];
        var groupedResources = {
          employees: [],
          rooms: [],
        };

        return ResourceDA.list().then(function(response) {
          _.forEach(response.resources, function(resource) {
            if (resource.type === 'room') {
              groupedResources.rooms.push({
                _id: resource._id,
                type: gettextCatalog.getString('Rooms'),
                label: resource.fullname,
              });
            } else {
              groupedResources.employees.push({
                _id: resource._id,
                type: gettextCatalog.getString('Employees'),
                label: resource.fullname,
              });
            }
          });

          if (groupedResources.employees.length > 0) {
            resources.push({
              _id: 'all-employees',
              type: gettextCatalog.getString('Employees'),
              label: gettextCatalog.getString('- All Employees -'),
            });
            resources = resources.concat(groupedResources.employees);
          }

          if (groupedResources.rooms.length > 0) {
            resources.push({
              _id: 'all-rooms',
              type: gettextCatalog.getString('Rooms'),
              label: gettextCatalog.getString('- All Rooms -'),
            });
            resources = resources.concat(groupedResources.rooms);
          }

          return resources;
        });
      },
    },
    params: {
      resource: function(LocalStorage) {
        var savedView = LocalStorage.get('calendarView');

        if (savedView && savedView.resource) {
          return savedView.resource;
        } else {
          return 'all-employees';
        }
      },
      date: function(LocalStorage) {
        var savedView = LocalStorage.get('calendarView');

        if (savedView && savedView.date) {
          return savedView.date;
        } else {
          return moment()
            .startOf('week')
            .format('YYYY-MM-DD');
        }
      },
      view: function(LocalStorage) {
        var savedView = LocalStorage.get('calendarView');

        if (savedView && savedView.view) {
          return savedView.view;
        } else {
          return 'week';
        }
      },
    },
  });
});



// WEBPACK FOOTER //
// ./src/app/modules/calendar/calendarModule.js